import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito turno?',
  a: 'Recomendamos reservar al 0341 719-8352 para garantizar tu horario sin esperas.'
}, {
  q: '¿Atienden los sábados?',
  a: 'Sí, de 10:00 a 14:00 — ideal para los que trabajan toda la semana.'
}, {
  q: '¿La barra es paga aparte?',
  a: 'Consultanos al reservar — parte de la experiencia Rotterdam es que te sentís bien desde que entrás.'
}, {
  q: '¿El Getting Ready es solo para el novio?',
  a: 'Es para el novio y todo su grupo — cerramos el salón para que sea una experiencia exclusiva.'
}, {
  q: '¿Con cuánta anticipación reservo el Getting Ready?',
  a: 'Cuanto antes mejor — las fechas de casamiento se agotan rápido.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 px-6 bg-rotterdam-black" data-id="element-77">
      <div className="max-w-3xl mx-auto" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-79">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6" data-id="element-80">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-81">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="border border-rotterdam-border bg-rotterdam-dark overflow-hidden" data-id="element-82">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-rotterdam-border/30 transition-colors" data-id="element-83">
                <span className="font-serif text-lg md:text-xl font-medium pr-8" data-id="element-84">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-rotterdam-gold pearl-icon transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-85" />
              </button>
              <AnimatePresence data-id="element-86">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-87">
                    <div className="px-6 pb-4 text-rotterdam-gray" data-id="element-88">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}